export default __webpack_public_path__ + "static/media/monkey5.ac85d549.JPG";